import React, { useState, useEffect } from 'react';
import { QrReader } from 'react-qr-reader';
import MainHeader from '../../Components/Header/MainHeader';
import { FaCamera, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import styles from './QCSHome.module.css';

const QCSHome = () => {
    const [scannedData, setScannedData] = useState(null);
    const [isCameraOpen, setIsCameraOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [cameraPermissionGranted, setCameraPermissionGranted] = useState(null);

    // Check if the user has granted camera access
    useEffect(() => {
        if (isCameraOpen) {
            navigator.mediaDevices
                .getUserMedia({ video: true })
                .then(() => setCameraPermissionGranted(true))
                .catch((error) => {
                    console.error("Error accessing camera:", error);
                    setCameraPermissionGranted(false);
                    setErrorMessage("Camera access denied. Please allow camera permissions.");
                });
        }
    }, [isCameraOpen]);

    const handleScan = (data) => {
        if (data) {
            console.log('Scanned Data:', data);
            setScannedData(data);
            setErrorMessage(""); // Clear any previous errors
            setIsCameraOpen(false); // Close camera after successful scan
        }
    };

    const handleError = (error) => {
        console.error('Error scanning QR code:', error);
        setErrorMessage("Unable to scan the QR code. Please try again.");
    };

    return (
        <div>
            <MainHeader />
            <div className={styles.mainWrapper}>
                <section className={styles.heroSection}>
                    <h1 className={styles.title}>Scan QR Codes to Earn Rewards!</h1>
                    <p className={styles.description}>
                        Earn loyalty reward points by scanning QR codes on our products. Redeem points to save on future purchases!
                    </p>
                    <div className={styles.ctaButtons}>
                        <button
                            className={styles.scanButton}
                            onClick={() => setIsCameraOpen(!isCameraOpen)}
                        >
                            <FaCamera /> {isCameraOpen ? 'Close Scanner' : 'Open Scanner'}
                        </button>
                    </div>
                </section>

                {isCameraOpen && cameraPermissionGranted === null && (
                    <p>Checking camera access...</p>
                )}

                {isCameraOpen && cameraPermissionGranted === false && (
                    <div className={styles.errorMessage}>
                        <FaExclamationCircle className={styles.errorIcon} />
                        <p>{errorMessage}</p>
                    </div>
                )}

                {isCameraOpen && cameraPermissionGranted && (
                    <div className={styles.qrScanner}>
                        <h3 className={styles.cameraLabel}>Camera Preview</h3>
                        <QrReader
                            key="environment"
                            scanDelay={ 300 }
                            constraints={{
                                facingMode: 'environment', // Use the back camera on mobile devices
                                aspectRatio: { ideal: 1 }
                            }}
                            onResult={(result, error) => {
                                if (result?.text) {
                                    handleScan(result.text);
                                }
                                if (error) {
                                    handleError(error); // Log and handle the error
                                }
                            }}
                            videoStyle={{ width: 300, height: 300, border: 'solid', borderWidth: '4px', borderColor: 'red' }}
                            containerStyle={{
                                width: '100%',
                                height: '500px', // Set a fixed height to make sure the video is visible
                                margin: '0 auto',
                                position: 'relative',
                                backgroundColor: 'black', // Set background color to black to indicate the video area
                                borderRadius: '8px',
                                display: 'block', // Ensure it's displayed properly
                            }}
                        // ViewFinder={scanOverlay}

                        />
                    </div>
                )}

                {scannedData && (
                    <div className={styles.successMessage}>
                        <FaCheckCircle className={styles.successIcon} />
                        <p>Successfully Scanned: <strong>{scannedData}</strong></p>
                        <button
                            className={styles.redeemButton}
                            onClick={() => console.log('Redeem points logic here')}
                        >
                            Redeem Points
                        </button>
                    </div>
                )}

                {errorMessage && (
                    <div className={styles.errorMessage}>
                        <FaExclamationCircle className={styles.errorIcon} />
                        <p>{errorMessage}</p>
                    </div>
                )}

                <section className={styles.gifWrapper}>
                    <img
                        src="https://cdn-icons-gif.flaticon.com/7994/7994392.gif"
                        alt="Rewards Animation"
                        className={styles.gif}
                    />
                    <img
                        src="https://i.pinimg.com/originals/95/c8/db/95c8db5e266eaa21573d011d5cf0c883.gif"
                        alt="Scan to earn"
                        className={styles.gif}
                    />
                </section>
            </div>
        </div>
    );
};

export default QCSHome;